'use strict';

var FilterList = {};
var StoreService = require('../services/store-service');

var $filterList = $('.list-group-scroll');
var entries = $('.js-filter-list').data('entries');
var $currentFacets = $filterList.html();
var filterText = '';

function matchElements(element) {
  var regex = new RegExp(filterText, 'gi');
  return regex.test(element.slugName);
}

function checkRegex(filterText) {
  var isValid = true;
  try {
    new RegExp(filterText);
  } catch (e) {
    isValid = false;
  }
  return isValid;
}

function prepareElements(elements) {
  for (var i = 0, len = (elements || []).length; i < len; i++) {
    elements[i] = setStyle(elements[i], filterText);
  }
  return elements;
}

function setStyle(element, filterText) {
  var regex = new RegExp('(' + filterText + ')', 'gi');
  element.name = element.name.replace(regex, '<strong>$1</strong>');
  return element;
}

function renderFilteredList(filteredList) {
  var tpl = '';
  (filteredList || []).forEach(function (facet) {
    tpl +=
      '<li class="filter-item filter-item-dinamic"><a href="' +
      facet.uri +
      '" class="filter-item-link" data-selected-filter="item-marca">';
    if (!facet.noicon) {
      tpl +=
        '<span class="filter-checkbox' +
        (facet.selected ? ' filter-checkbox-checked"> <i></i>' : '">') +
        '</span>';
    }
    tpl += '<span class="filter-item-text">' + facet.name + '</span></a></li>';
  });

  return tpl;
}

FilterList.getCurrentFacets = function (currentFacets) {
  $filterList = $('.list-group-scroll');
  entries = $(currentFacets).find('.js-filter-list').data('entries');
  $currentFacets = $(currentFacets).find('.list-group-scroll').html();
  filterText = '';
};

$('body').on(
  'keyup',
  '.js-filter-list',
  StoreService.debounce(50, function (event) {
    event.stopPropagation();
    $('#accordion-checks-brand').prop('checked', true);
    $('.checks-brand-see-more').addClass('is-hide');
    var noResult = [
      {
        name: 'Nenhuma Marca Encontrada',
        selected: false,
        uri: '#',
        slugName: '',
        noicon: true
      }
    ];

    var filteredList = [];
    filterText = StoreService.slugify(this.value || '');

    if (filterText && checkRegex(filterText)) {
      var matched = JSON.parse(JSON.stringify(entries));

      filteredList = prepareElements((matched || []).filter(matchElements));
      filteredList = filteredList.length ? filteredList : noResult;

      $filterList.addClass('isDinamic');
      $filterList.html(renderFilteredList(filteredList));
    } else {
      $filterList.removeClass('isDinamic');
      $filterList.html($currentFacets);
      $('#accordion-checks-brand').prop('checked', false);
      $('.checks-brand-see-more').removeClass('is-hide');
    }
  })
);

module.exports = FilterList;
